import { Cart } from 'src/components/context';

export interface CartItemInput {
  productId: number;
  quantity: number;
}

/**
 * Flattens a cart into the shape fillCart expects.
 *
 * There is deliberately no client-side merge helper here. fillCart ADDS to whatever
 * the cart already holds (verified: quantity 2 filled with 3 becomes 5), so callers
 * pass only the NEW items and let the server sum duplicates. Pre-merging on the client
 * double-counts everything already in the basket.
 */
export const cartToItems = (cart?: Cart | null): CartItemInput[] =>
  (cart?.contents?.nodes ?? []).reduce<CartItemInput[]>((items, node) => {
    const productId = node?.product?.node?.databaseId;

    if (!productId) {
      return items;
    }

    items.push({ productId, quantity: node.quantity ?? 0 });

    return items;
  }, []);
